<div *hasScope="SCOPES.CANCELLATION_REASONS.READ_ALL">
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between">
      <h1 class="titleColor text-2xl font-bold" i18n="@@adminSidebarCancellationReasons">Cancellation Reasons</h1>

      <div *hasScope="SCOPES.CANCELLATION_REASONS.CREATE">
        <a
          routerLink="/admin/cancellation/create-cancellation-reason"
          class="add-button flex items-center justify-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
          </svg>

          <span i18n="@@cancellationReasonsCreate">Create New Reason</span>
        </a>
      </div>
    </div>
  </div>

  <div class="mb-4 rounded-2xl pt-3 pb-4">
    <app-cancellation-reasons-list-component></app-cancellation-reasons-list-component>
  </div>
</div>
